export const API = "https://api.pujakaitem.com/api/products";
export const URL = "https://e-comm-champa-store.onrender.com";
